<template>
  <div></div>
</template>

<script>
// Função que realiza tratamento de erros
function checkErros(self, erros) {
  if (!Array.isArray(erros)) return false

  let requestErros = erros.filter((elm) => elm.status == 'rejected')

  if (requestErros) {
    for (var i = 0; i < requestErros.length; i++) {
      let errorCode = requestErros[i].reason.response.data.ErrorCode

      // 160076 - ORGANIZATION_DOES_NOT_HAVE_AN_ACTIVE_PLAN
      if (errorCode == 160076) {
        // self.$store.commit('HIDE_BASE_MENU')
        // self.$router.push({ name: 'manage-balance-plans' })
        break
      }
    }
    return true
  }
  return false
}

export default {
  mounted() {
    if (localStorage.getItem('accessToken')) {
      this.$store.commit('auth/AUTH_USER_LOGGED')
      // Quando possui organização selecionada
      if (this.$route.params.organizationId) {
        this.$store
          .dispatch('auth/getUserSession', this.$route.params.organizationId)
          .then(() => {
            this.$root.$emit('chooseLang', this.$store.state.lang || 'en-US')
            this.redirectRoute()
          })
          .catch((err) => {
            if (!checkErros(this, err)) {
              this.$store.dispatch('auth/logout')
            }
          })
        // Quando não possui organização selecionada
      } else {
        this.$store
          .dispatch('auth/getUserSession')
          .then(() => {
            this.$root.$emit('chooseLang', this.$store.state.lang || 'en-US')
            this.redirectRoute()
          })
          .catch((err) => {
            if (!checkErros(this, err)) {
              this.$store.dispatch('auth/logout')
            }
          })
      }
    } else {
      this.$store.commit('auth/DEFAULT_AUTH_STATE')
      this.$store.commit('CLOSE_NOTIFICATION_LOOP')
      this.$store.commit('whitelabel/RESET_TO_DEFAULT')

      if (this.$route.query.next === 'setOrganization') {
        this.$router.push({ name: 'Login', query: { so: this.$route.params.id, page: this.$route.query.page } })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  },

  // computed: {
  //   dataSession() {
  //     return (
  //       this.$route.params.organizationId &&
  //       this.$store.state.session.feature.length &&
  //       this.$store.state.session.permissions.length &&
  //       this.$store.state.session.user &&
  //       this.$store.state.session.organization
  //     )
  //   },
  // },

  methods: {
    handleQueries(query) {
      let queries = {}
      Object.assign(queries, query)
      delete queries.next
      return queries
    },
    redirectRoute() {
      let session = this.$store.state.auth.session
      // Quantdo status da organização for pending_configuration
      if (session.organization.organizationStatus === 4) {
        this.$router.push({
          name: 'waitingConfiguration',
          query: this.handleQueries(this.$route.query),
          params: this.$route.params,
          hash: this.$route.hash,
        })
        return
      }
      this.$router.push({
        name: this.$route.query.next,
        query: this.handleQueries(this.$route.query),
        params: this.$route.params,
        hash: this.$route.hash,
      })
    },
  },
}
</script>

<style></style>
